import React, { useState } from 'react';
import { Search, Clock, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import blog1 from '../assets/images/AZ8_6268.jpg'
import blog2 from '../assets/images/AZ8_7106.jpg'
import blog3 from '../assets/images/AZ8_7185.jpg'
import { Box, Container, Typography, Button, styled } from '@mui/material';
import blog_image from '../assets/images/blog.jpg'
import { Center } from '@react-three/drei';
// Blog posts data
const blogPosts = [
  {
    id: 1,
    title: 'Crafting Excellence: The Story of Bhagwati Products Limited’s Engineering Achievements',
    excerpt: 'Bhagwati Products Limited is one of India’s leading engineering and manufacturing companies, specializing in the production of high-quality precision equipment and machinery for a range of industries. With an outstanding track record of engineering excellence, Bhagwati Products Limited has become a name synonymous with quality, innovation and reliability. In this blog post, we will take a deeper look at the engineering achievements of Bhagwati Products Limited, its impressive range of products and what sets it apart from the competition.',
    image: blog1,
    author: {
      name: 'Admin',
      avatar: 'https://th.bing.com/th/id/R.8e2c571ff125b3531705198a15d3103c?rik=muXZvm3dsoQqwg&riu=http%3a%2f%2fpluspng.com%2fimg-png%2fpng-user-icon-person-icon-png-people-person-user-icon-2240.png&ehk=MfHYkGonqy7I%2fGTKUAzUFpbYm9DhfXA9Q70oeFxWmH8%3d&risl=&pid=ImgRaw&r=0',
    },
    date: 'AUG 28, 2023'
  },
  {
    id: 2,
    title: 'India’s Import Restrictions on Laptops and Tablets Receives Local Praise',
    excerpt: 'Recently, India made a bold move by imposing import restrictions on laptops and tablets. While this step has been criticized by many, it has received significant local praise from electronic manufacturing experts. India has been aiming to become a self-sufficient country in producing electronic devices for a long time. This new policy, which is a part of the government’s ‘Make in India’ campaign, seems to be a significant step toward achieving that goal. In this blog post, we will explore the reasons behind this move and why it has been praised by electronic manufacturing experts.',
    
    image: blog2,
    author: {
      name: 'Admin',
      avatar: 'https://th.bing.com/th/id/R.8e2c571ff125b3531705198a15d3103c?rik=muXZvm3dsoQqwg&riu=http%3a%2f%2fpluspng.com%2fimg-png%2fpng-user-icon-person-icon-png-people-person-user-icon-2240.png&ehk=MfHYkGonqy7I%2fGTKUAzUFpbYm9DhfXA9Q70oeFxWmH8%3d&risl=&pid=ImgRaw&r=0',
    },
    date: 'AUG 28, 2023'
  },
  {
    id: 3,
    title: 'Indian Government Revives Domestic IT Manufacturing with PLI Scheme',
    excerpt: 'The Indian government’s Production Linked Incentive (PLI) scheme has taken yet another step to boost domestic IT manufacturing in the country. The PLI scheme, which was launched last year, offers incentives for companies manufacturing electronics and semiconductors in India. The scheme seeks to promote domestic production and reduce the country’s reliance on imported electronics. The IT sector is among the sectors that stand to benefit from the scheme, with the Indian government targeting a significant increase in domestic IT manufacturing in the next few years. This blog post examines the impact of the PLI scheme on the IT sector in India and the country’s quest to gain greater technological independence.',
    
    image: blog3,
    author: {
      name: 'Admin',
      avatar: 'https://th.bing.com/th/id/R.8e2c571ff125b3531705198a15d3103c?rik=muXZvm3dsoQqwg&riu=http%3a%2f%2fpluspng.com%2fimg-png%2fpng-user-icon-person-icon-png-people-person-user-icon-2240.png&ehk=MfHYkGonqy7I%2fGTKUAzUFpbYm9DhfXA9Q70oeFxWmH8%3d&risl=&pid=ImgRaw&r=0',
    },
    date: 'AUG 24,2023'
  }
];

const BlogCard = ({ post }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow overflow-hidden flex flex-col h-full">
      <div className="relative h-48 w-full">
        <img
          src={post.image}
          alt={post.title}
          className="object-cover w-full h-full"
        />
        
      </div>
      <div className="p-6 flex flex-col flex-grow">
        <div className="flex items-center space-x-2 mb-2">
          <img
            src={post.author.avatar}
            alt={post.author.name}
            className="w-6 h-6 rounded-full"
          />
          <span className="text-sm text-gray-600">{post.author.name}</span>
          <span className="text-sm text-gray-400">•</span>
          <span className="text-sm text-gray-600">{post.date}</span>
        </div>
        <h3 className="text-xl font-semibold mb-2 line-clamp-2">{post.title}</h3>
        <p className="text-gray-600 mb-4 line-clamp-3">{post.excerpt}</p>
        <button
          onClick={() => navigate(`/blog/${post.id}`)}
          className="mt-auto flex items-center text-black hover:text-blue-800 transition-colors"
        >
          Read More
          <ArrowRight className="ml-2 w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
const RecentPosts = ({ posts }) => (
  <div className="bg-gray-50 p-6 rounded-lg">
    <div className="flex items-center mb-4">
      <Clock className="w-5 h-5 mr-2 text-black" />
      <h2 className="text-xl font-semibold">Recent Posts</h2>
    </div>
    <div className="space-y-4">
      {posts.slice(0, 3).map(post => (
        <div key={post.id} className="flex items-start space-x-4">
          <img
            src={post.image}
            alt={post.title}
            className="w-16 h-16 object-cover rounded"
          />
          <div>
          
            <h3 className="font-medium line-clamp-2">{post.title}</h3>
            <span className="text-sm text-gray-600">{post.date}</span>
          </div>
        </div>
      ))}
    </div>
  </div>
);


const SearchBar = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value);
  };

  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
      <input
        type="text"
        placeholder="Search blogs..."
        value={searchTerm}
        onChange={handleSearch}
        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent outline-none"
      />
    </div>
  );
};
const DetailedPost = ({ post, onClose }) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
    <div className="bg-white rounded-lg max-w-3xl w-full max-h-[90vh] overflow-y-auto">
      <div className="p-6">
        <img
          src={post.image}
          alt={post.title}
          className="w-full h-64 object-cover rounded-lg mb-6"
        />
        
        <h1 className="text-3xl font-bold mt-4 mb-2">{post.title}</h1>
        <div className="flex items-center space-x-4 mb-6">
          <img
            src={post.author.avatar}
            alt={post.author.name}
            className="w-10 h-10 rounded-full"
          />
          <div>
            <p className="font-medium">{post.author.name}</p>
            <p className="text-gray-600 text-sm">{post.date}</p>
          </div>
        </div>
        <div className="prose max-w-none">
          <p>{post.excerpt}</p>
          <p className="mt-4">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor 
            incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis 
            nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          </p>
        </div>
        <button
          onClick={onClose}
          className="mt-6 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
        >
          Close
        </button>
      </div>
    </div>
  </div>
);

export default function Blogs() {
  const [searchTerm, setSearchTerm] = useState("");
  
  const [filteredPosts, setFilteredPosts] = useState(blogPosts);
  const [selectedPost, setSelectedPost] = useState(null);

  const handleSearch = (searchTerm) => {
    if (!searchTerm.trim()) {
      setFilteredPosts(blogPosts);
    } else {
      const filtered = blogPosts.filter(post =>
        post.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredPosts(filtered);
    }
  };
  return (
    <div className=" ">
    {/* Hero Section */}
    <Box
  sx={{
    minHeight: { xs: 'auto', md: '60vh' },
    position: 'relative',
    overflow: 'hidden',
    py: { xs: 8, md: 0 },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#000', // Fallback background color
  }}
>
  {/* Background Image with Blur */}
<div
  style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundImage: `url(${blog_image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    zIndex: 0,
    filter: 'blur(1px)', // Adds blur effect
  }}
></div>

  {/* Content */}
  <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '1fr' },
        gap: { xs: 6, md: 12 },
        alignItems: 'center',
        color: '#fff', // Text color for visibility
        textShadow: '0 0 10px rgba(0, 0, 0, 0.7)', // Text shadow for readability
      }}
    >
      {/* Left Content */}
      <Box>
        <Typography
          className="hero-title"
          variant="h1"
          textAlign="center"
          sx={{
            fontSize: { xs: '2.5rem', sm: '3rem', md: '3.5rem', lg: '4rem' },
            fontWeight: 500,
            lineHeight: 1.2,
            mb: 4,
          }}
        >
         
Blogs
        </Typography>
        
      </Box>
    </Box>
  </Container>
</Box>
      <div className="px-4 pt-10 flex flex-col lg:flex-row gap-8">
        <div className="lg:w-3/4">
          
          {filteredPosts.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {filteredPosts.map(post => (
                <BlogCard
                  key={post.id}
                  post={post}
                  onReadMore={() => setSelectedPost(post)}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <h2 className="text-2xl font-semibold mb-4">No posts found</h2>
              <p className="text-gray-600">
                We couldn't find any posts matching your search. Try adjusting your search terms or browse our recent posts.
              </p>
            </div>
          )}
        </div>
        <div className="lg:w-1/4">
        <div className="mb-6">
          <SearchBar onSearch={handleSearch} />
          </div>
          <RecentPosts posts={blogPosts} />
        </div>
      </div>

      {selectedPost && (
        <DetailedPost
          post={selectedPost}
          onClose={() => setSelectedPost(null)}
        />
      )}
      <br></br>
    </div>
  );
}

